// extracted by extract-css-chunks-webpack-plugin
module.exports = {"keywords-list":"styles__keywords-list___1OEjv","keywordsList":"styles__keywords-list___1OEjv","clipboard":"styles__clipboard___1ezEc","input":"styles__input___3sR2i"};
    if(module.hot) {
      // 1773794978936
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  